import { useGetMe, useGetViewupPlusSnsAccounts, useGetViewupSnsAccounts } from 'Shared/hooks/api';
import { Analytics } from 'Shared/utils/client';
import { LINK } from '@constants';
import {
  ArrowRight,
  Button,
  Column,
  Icon,
  PointWhiteBg,
  Row,
  Speaker,
  Typography,
} from '@viewup/ui';
import { EmptyViewingMoneyModal } from 'app/_components/EmptyViewingMoneyModal';
import { useGlobalModalStore } from 'app/_hook';
import { useGetEarnedPoints } from 'app/viewing-money/_features/api';
import { useRouter } from 'next/navigation';
import { handleChangeStatus, informationStyle } from './ViewerInformation.const';

export const ViewerInformation = () => {
  const router = useRouter();
  const { data: snsAccounts } = useGetViewupSnsAccounts();
  const { data: snsPlusAccounts } = useGetViewupPlusSnsAccounts();
  const { data } = useGetMe({ options: { enabled: true } });
  const { data: earnedPoints } = useGetEarnedPoints();
  const exchangeablePoint = earnedPoints?.data.exchangeablePoint || 0;
  const { getValue } = useGlobalModalStore();
  const { setAlertModal } = getValue('actions');

  return (
    <Column bgColor='system.white' gap={16} p={16}>
      <Column gap={2}>
        <Typography color='text.tertiary' fontType='body2.regular'>
          한 눈에 살펴보는
        </Typography>
        <Row alignItems='center' justifyContent='space-between'>
          <Row alignItems='flex-end' gap={4}>
            <Typography color='text.primary' fontType='header2.medium'>
              {data?.data.nickname}
            </Typography>
            <Typography color='text.tertiary' fontType='body2.regular'>
              님
            </Typography>
          </Row>
          <Button
            onClick={() => router.push(LINK.MY_VIEWUP_INFO)}
            rightContent={<Icon size='3XS' source={ArrowRight} />}
            size={'XS'}
            styledComponents={{
              root: { color: 'text.tertiary' },
            }}
            variant='ghost.assistive'
          >
            내정보
          </Button>
        </Row>
      </Column>

      {snsAccounts && snsPlusAccounts && (
        <Column bgColor='bg.infoDimmer' br={12} gap={8} p={12} position='relative'>
          <Row
            bgColor='system.white'
            {...informationStyle}
            onClick={() => {
              if (
                snsAccounts?.data.find((item) => item.snsAccountError) ||
                snsPlusAccounts.data.find((item) => item.snsAccountError)
              ) {
                Analytics.getInstance().track('MY_VIEWUP_ERROR_ACCOUNT_SETTING');
                return router.push(`${LINK.MY_VIEWUP_ACCOUNT}?type=error`);
              }
              return router.push(LINK.MY_VIEWUP_ACCOUNT);
            }}
          >
            {handleChangeStatus(snsAccounts, snsPlusAccounts)}
          </Row>
          <Row
            bgColor='bg.info'
            {...informationStyle}
            onClick={() => {
              EmptyViewingMoneyModal(data?.data.totalPoint || 0, router, setAlertModal);
            }}
          >
            <Row alignItems='center' gap={4}>
              <Icon color='icon.point' size='XS' source={PointWhiteBg} />
              <Typography color='system.white' fontType='body2.regular'>
                {exchangeablePoint > 0
                  ? '뷰업 포인트를 이만큼 모았어요'
                  : '뷰업 포인트를 모아보세요!'}
              </Typography>
            </Row>
            <Typography color='system.white' fontType='body.medium'>
              {exchangeablePoint.toLocaleString()}P
            </Typography>
          </Row>
        </Column>
      )}

      <Row
        alignItems='center'
        bgColor='bg.infoSubtle'
        br={12}
        css={{ cursor: 'pointer' }}
        gap={4}
        justifyContent='space-between'
        onClick={() =>
          window.open(
            'https://smiledragon.notion.site/f07b6531f45e4e8a8c7badb6e442ed94?pvs=74',
            '_blank',
          )
        }
        pl={16}
        pr={12}
        py={12}
      >
        <Row gap={16}>
          <Icon color='icon.info' source={Speaker} />
          <Column gap={4}>
            <Typography color='text.tertiary' fontType='caption.regular'>
              뷰업의 새로운 소식을 알려드려요
            </Typography>
            <Typography color='text.primary' fontType='body2.medium'>
              드디어 뷰업가이드가 생겼어요!
            </Typography>
          </Column>
        </Row>
        <Icon size='S' source={ArrowRight} />
      </Row>
    </Column>
  );
};
